import { render, staticRenderFns } from "./TabsPage.vue?vue&type=template&id=1fada33a&scoped=true&"
import script from "./TabsPage.vue?vue&type=script&lang=js&"
export * from "./TabsPage.vue?vue&type=script&lang=js&"
import style0 from "./TabsPage.vue?vue&type=style&index=0&id=1fada33a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fada33a",
  null
  
)

export default component.exports